class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverMediaQuery = window.matchMedia('(hover: hover)');
    this.summary = this.mainDetailsToggle.querySelector('summary');

    this.openMenu = this.openMenu.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.onNestedSummaryClick = this.onNestedSummaryClick.bind(this);

    this.summary.addEventListener('click', this.onSummaryClick);

    if (this.hoverMediaQuery.matches) {
      this.addEventListener('mouseenter', this.openMenu);
      this.addEventListener('mouseleave', this.close.bind(this));
    }

    this.querySelectorAll('details').forEach((details) => {
      if (details === this.mainDetailsToggle) return;

      const nestedSummary = details.querySelector('summary');
      if (!nestedSummary) return;

      nestedSummary.addEventListener('click', this.onNestedSummaryClick);

      if (this.hoverMediaQuery.matches) {
        details.addEventListener('mouseenter', () => {
          details.setAttribute('open', '');
          nestedSummary.setAttribute('aria-expanded', 'true');
        });
        details.addEventListener('mouseleave', () => {
          details.removeAttribute('open');
          nestedSummary.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  openMenu() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
    this.onToggle();
  }

  onSummaryClick(event) {
    const link = event.target.closest('a');

    if (link) {
      event.preventDefault();
      window.location.assign(link.href);
      return;
    }

    if (this.hoverMediaQuery.matches) {
      event.preventDefault();
    }
  }

  onNestedSummaryClick(event) {
    const link = event.target.closest('a');

    if (link) {
      event.preventDefault();
      window.location.assign(link.href);
      return;
    }

    if (this.hoverMediaQuery.matches) {
      event.preventDefault();
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
